import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';
import trans from './translation';
import './student.css'

import CohortProgModal from './cohortProgModal';

const RoleFromModal = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const studentModel = props.studentModel;
    const [studentProgModel, setStudentProgModel] = useState(props.studentProgModel);
    const [flag, setFlag] = useState(props.studentProgFormFlag);
    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState(props.studentProgModel);
    const [spinInfo, setSpinInfo] = useState("");

    useEffect(() => {
        initForm(studentProgModel)
    }, []);

    const initForm = (model, flag) => {
        if (flag) {
            form.setFieldsValue({
                progCode: model.progCode ?? "",
                progTitle: model.progTitle ?? "",
            });
        } else {
            form.setFieldsValue({
                cohortProgId: model.cohortProgId ?? "",
                progCode: model.progCode ?? "",
                progTitle: model.progTitle ?? "",
                studentEntryYear: model.studentEntryYear ?? "",
                studyYearEntry: model.studyYearEntry ?? "",
            });
        }
    }

    const save = () => {
        form.submit();
    }

    const onFinish = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        model.userId = studentModel.userId;
        model.cohortProgId = cohortProgModel.cohortProgId
        let url = "";
        if (flag === "add") {
            url = "studentProgramme/insert";
        } else if (flag === "edit") {
            url = "studentProgramme/update";
            model.studentProgId = studentProgModel.studentProgId
            model.lastUpdatedDate = studentProgModel.lastUpdatedDate;
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
                onCancel(true)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const selectCohortProgramme = () => {
        setIsCohortProgModal(true)
    }

    const closeCohortProg = (flag, model) => {
        if (flag) {
            initForm(model, true)
            setCohortProgModel(model)
        }
        setIsCohortProgModal(false);
    }

    return (
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                className='studentProgFormModal'
                visible={true}//控制弹框是否显示
                title={trans.studentProgFormModalTitle[Config.backLang]}//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'1000px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                <Message ref={messageRef} />
                <Form form={form} onFinish={onFinish}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.progCode[Config.backLang]}</div>
                            <div className="sysInput datePicker">
                                <Form.Item
                                    name="progCode"
                                    rules={[
                                        { required: true, message: trans.progCodeIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Input type="text"
                                        placeholder={trans.progCode[Config.backLang]} maxLength={100} disabled
                                    />
                                </Form.Item>
                            </div>
                            <Button key='selectCohortProgramme' className="sysBtn btnBlue" onClick={selectCohortProgramme}>{trans.select[Config.backLang]}</Button>
                        </div>
                        <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.progTitle[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="progTitle"
                                    rules={[
                                        { required: true, message: trans.progTitleIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Input type="text"
                                        placeholder={trans.progTitle[Config.backLang]} maxLength={100} disabled
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        {/* <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.prog[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="cohortProgId"
                                    rules={[
                                        { required: true, message: trans.progCodeIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Select placeholder={trans.progCode[Config.backLang]} className='sysSelect'>
                                        <Option value=""></Option>
                                        {Config.cohortProgList.map((item) => <Option key={item.cohortProgId} value={item.cohortProgId}>{item.progCode}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div> */}
                    </div>
                    <div className='sysRow'>
                        {/* <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.cohortYear[Config.backLang]} </div>
                            <div className="sysInput">
                                <Form.Item
                                    name="cohortYear"
                                    rules={[
                                        { required: true, message: trans.cohortYearIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <DatePicker placeholder={trans.cohortYear[Config.backLang]}
                                        className="parts-numberInput datePickerAllWidth"
                                        picker="year"
                                        disabled
                                        format={Config.dateFormat7} />
                                </Form.Item>
                            </div>
                        </div> */}
                        <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.studentEntryYear[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="studentEntryYear"
                                    rules={[
                                        { required: true, message: trans.studentEntryYearIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Input type="text"
                                        placeholder={trans.studentEntryYear[Config.backLang]} maxLength={5}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysParam ">Study Year Entry</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="studyYearEntry"
                                >
                                    <Input type="text"
                                        placeholder='Study Year Entry' maxLength={20}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal>
            {isCohortProgModal && <CohortProgModal onClose={closeCohortProg} />}
        </Spin>
    )

}

RoleFromModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    studentModel: PropTypes.object.isRequired,
    studentProgModel: PropTypes.object.isRequired,
    studentProgFormFlag: PropTypes.string.isRequired,
}

export default RoleFromModal;